export const AMAZON_FINANCE_FEATURE_ID = 'gung-feature-seller-central-v2';
export const AMAZON_FINANCE_MINIMUM_GUNG_BASE_VERSION = '3.0.15';
